import { render } from "./addFile.vue?vue&type=template&id=234369de&scoped=true"
import script from "./addFile.vue?vue&type=script&lang=js"
export * from "./addFile.vue?vue&type=script&lang=js"

import "./addFile.vue?vue&type=style&index=0&id=234369de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234369de"]])

export default __exports__